/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-04 21:56:18
 */

import * as Vue from "vue-tsx-support";
import {Component, Prop} from 'vue-property-decorator'
import "vue-tsx-support/enable-check"
import Modal from "src/types/iview/Modal";
import Button from "src/types/iview/Button";
import Input from "src/types/iview/Input";
import {Toast} from "src/util/toast";
import {modalFactory} from "src/util/vueExtend";
import EnumOperates from "src/enums/enumOperates";
import OrganizationConfigApi, { OrganizationConfigDOI } from './api/organizationConfigApi';
import RegexCheck from 'src/util/regexCheck';

export namespace OrganizationOperateVOI {
	export interface PropsI {
		operate: string
        current?: OrganizationConfigDOI.RowDataI
        superior: {id: number, name: string}
		saveSuccess? (): void

		cancel? (): void
	}

}

@Component
class OrganizationOperateModal extends Vue.Component<any> {
	@Prop({
		type: Function
	})
	cancel!: () => void

	@Prop({
		type: Object
	})
    current!: OrganizationConfigDOI.RowDataI
    
    @Prop({
		type: Object
	})
	superior!:{id: number, name: string}

	@Prop({
		type: String
	})
	operate!: string

	@Prop({
		type: Function
	})
	saveSuccess!: () => void

	visible: boolean = false

	loading: boolean = false

	formData: OrganizationConfigDOI.OperateParamsI = {
        name: '',
        principal: '',
        phone: '',
        remark: '',
        parent_id: null,

	}
	rules: any = {}

	close () {
		this.cancel && this.cancel()
		this.closeModal()
	}

	closeModal() {
		this.visible = false
		this.$emit('close', false)
	}

	async save () {
		if(!await this.$validate('formValidate')) {
			return
		}
		let res
		this.loading = true
		let params:OrganizationConfigDOI.OperateParamsI = {
			...this.formData,
		}
		switch (this.operate) {
			case EnumOperates.Add.getName():
				res = await OrganizationConfigApi.add(params)
				break
			case EnumOperates.Update.getName():
                params.id = this.current.id
				res = await OrganizationConfigApi.update(params)
				break
		}
		this.loading = false
		let {code} = res
		if (code === 0) {
			Toast.success(this.operate+'成功')
			this.saveSuccess()
			this.closeModal()
		}
    }
    mounted() {
        this.formData.parent_id = this.superior.id
        if(this.operate === EnumOperates.Update.getName()) {
            this.formData = {
                ...this.current,
            }
        }
    }
    created() {
        this.rules = {
            phone: [
                { validator: RegexCheck.checkBasicPhone, trigger: 'blur' },
            ],
        };
    }
	render (h) {
		return (
			<Modal
				title={this.operate+"组织"}
				width="500"
				v-model={this.visible}
				mask-closable={false}
				on-on-cancel={this.close}
			>
				<i-form ref="formValidate"  labelWidth={100} model={this.formData} rules={this.rules} style="width:80%">
					<form-item label="上级组织"  >
						{this.superior.name}
					</form-item>
                    <form-item label="部门名称"  prop="name" required>
						<Input v-model={this.formData.name} placeholder="请输入"></Input>
					</form-item>
                    <form-item label="负责人"  prop="principal" >
						<Input v-model={this.formData.principal} placeholder="请输入"></Input>
					</form-item>
                    <form-item label="联系电话"  prop="phone" >
						<Input v-model={this.formData.phone} placeholder="请输入"></Input>
					</form-item>
                    <form-item label="备注"  prop="remark" >
                        <Input placeholder="请输入" v-model={this.formData.remark} type="textarea"/>
					</form-item>
				</i-form>
				<div slot="footer">
					<Button type="primary" ghost on-click={this.close}>取消</Button>
					<Button type="primary" on-click={this.save} loading={this.loading}>保存</Button>
				</div>
			</Modal>
		);
	}
}

export default function alertOrganizationOperateModal (operate: string,superior: {id: number, name: string}, current?: OrganizationConfigDOI.RowDataI): Promise<boolean> {
		return new Promise((resolve, reject) => {
			modalFactory<OrganizationOperateVOI.PropsI>(OrganizationOperateModal)({
				current,
                operate,
                superior,
				saveSuccess () {
					resolve(true)
				},
				cancel () {
					resolve(false)
				}
			})
		})
	}
